// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oNP3UfDF2QkdkxkYOJTH{margin-bottom:22px}.oNP3UfDF2QkdkxkYOJTH:last-of-type{margin-bottom:0}.dWjCmNIoPvUx1heILyVT{align-items:center;height:32px;margin-bottom:3px;padding:4px 8px;display:flex}.zJzIbLQ2fhY_cRvqpuSx{flex-direction:column;gap:2px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `oNP3UfDF2QkdkxkYOJTH`,
	"title": `dWjCmNIoPvUx1heILyVT`,
	"container": `zJzIbLQ2fhY_cRvqpuSx`
};
export default ___CSS_LOADER_EXPORT___;
